var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.movies == null)?_c('div',[_vm._v(" loading ")]):_c('div',[_vm._l((_vm.movies.data),function(movie){return _c('movie-item-horizontal-component',{key:movie.slug,attrs:{"movie":movie}})}),_c('paginate-component',_vm._b({},'paginate-component',_vm.movies,false))],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }